module.exports = __webpack_public_path__ + "img/icone-folhas.c438c6dd.svg";